import React, { useState, useEffect } from 'react';
import UpgradeModal from './UpgradeModal';

const GlobalModalManager = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    message: '',
    limit: undefined,
    currentCount: undefined,
    requiredFeature: ''
  });

  useEffect(() => {
    const handleShowUpgrade = (event) => {
      const detail = event.detail;
      if (detail) {
        setModalState({
          isOpen: true,
          message: detail.message,
          limit: detail.limit,
          currentCount: detail.currentCount,
          requiredFeature: detail.requiredFeature
        });
      }
    };

    window.addEventListener('showUpgradeModal', handleShowUpgrade);
    return () => window.removeEventListener('showUpgradeModal', handleShowUpgrade);
  }, []);

  const handleClose = () => {
    setModalState(prev => ({ ...prev, isOpen: false }));
  };

  return (
    <UpgradeModal 
      isOpen={modalState.isOpen}
      onClose={handleClose}
      message={modalState.message}
      limit={modalState.limit}
      currentCount={modalState.currentCount}
      requiredFeature={modalState.requiredFeature}
    />
  );
};

export default GlobalModalManager;
